import axios from 'axios';
import Config from 'Config';
import { createSignedRequest } from 'utils/createSignedRequest';

export const acceptChatbotTermsThunkService = async (userId) => {
  console.log(acceptChatbotTermsThunkService);

  console.log(userId);

  const apiPath = `chatbot/accept-terms`;

  const bodyItemToSend = { userId };

  const request = {
    // url: `http://localhost:3001/${apiPath}`,
    url: `https://${process.env.REACT_APP_WORK_CALENDAR_API_URL}/${apiPath}`,
    host: process.env.REACT_APP_WORK_CALENDAR_API_URL,
    path: apiPath,
    method: 'POST',
    region: Config.AWS_REGION,
    service: 'execute-api',
    headers: {
      'Content-Type': 'application/json',
    },
    body: JSON.stringify(bodyItemToSend),
    data: bodyItemToSend,
  };

  const signedRequest = await createSignedRequest(request);

  const res = await axios(signedRequest);

  return res.data;
};

export const getHaveIAcceptedChatbotTermsService = async (userId) => {
  const apiPath = `chatbot/have-i-accepted-terms/${userId}`;
  const request = {
    // url: `http://localhost:3001/${apiPath}`,
    url: `https://${process.env.REACT_APP_WORK_CALENDAR_API_URL}/${apiPath}`,
    host: process.env.REACT_APP_WORK_CALENDAR_API_URL,
    path: apiPath,
    method: 'GET',
    region: Config.AWS_REGION,
    service: 'execute-api',
  };

  const signedRequest = await createSignedRequest(request);
  const response = await fetch(signedRequest.url, {
    method: signedRequest.method,
    headers: signedRequest.headers,
  });

  return await response.json();
};

export const getChatbotThreadsService = async (businessId) => {
  const apiPath = `chatbot/threads/${businessId}`;
  const request = {
    // url: `http://localhost:3001/${apiPath}`,
    url: `https://${process.env.REACT_APP_WORK_CALENDAR_API_URL}/${apiPath}`,
    host: process.env.REACT_APP_WORK_CALENDAR_API_URL,
    path: apiPath,
    method: 'GET',
    region: Config.AWS_REGION,
    service: 'execute-api',
  };

  const signedRequest = await createSignedRequest(request);
  const response = await fetch(signedRequest.url, {
    method: signedRequest.method,
    headers: signedRequest.headers,
  });

  return await response.json();
};
